import React from 'react';

const DistanceIcon = ({ ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="44" height="8" viewBox="0 0 44 8" fill="none" {...rest}>
      <path d="M0.833333 4C0.833333 5.47276 2.02724 6.66667 3.5 6.66667C4.97276 6.66667 6.16667 5.47276 6.16667 4C6.16667 2.52724 4.97276 1.33333 3.5 1.33333C2.02724 1.33333 0.833333 2.52724 0.833333 4ZM43.8536 4.35355C44.0488 4.15829 44.0488 3.84171 43.8536 3.64645L40.6716 0.464466C40.4763 0.269204 40.1597 0.269204 39.9645 0.464466C39.7692 0.659728 39.7692 0.976311 39.9645 1.17157L42.7929 4L39.9645 6.82843C39.7692 7.02369 39.7692 7.34027 39.9645 7.53553C40.1597 7.7308 40.4763 7.7308 40.6716 7.53553L43.8536 4.35355ZM3.5 4.5L43.5 4.5V3.5L3.5 3.5V4.5Z" fill="#6D7885" />
    </svg>
  );
};

export default DistanceIcon;